export const RESUME_SET_DATA = 'RESUME_SET_DATA';
export const RESUME_RESET_STATE = 'RESUME_RESET_STATE';
export const RESUME_SET_DATE_FROM = 'RESUME_SET_DATE_FROM';
export const RESUME_SET_DATE_TO = 'RESUME_SET_DATE_TO';



/** WEBPACK FOOTER **
 ** ./src/store/modules/report/resume/types.js
 **/